(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-about-artisans"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-about-artisans"].rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      roots.forEach(function(el){ io.observe(el); });
    }

    document.querySelectorAll('[data-section-type="cs-about-artisans"]').forEach(function(root){
      var tabs = root.querySelectorAll('[data-as-tab-index]');
      var panels = root.querySelectorAll('[data-as-panel-index]');
      tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
          var idx = tab.getAttribute('data-as-tab-index');
          tabs.forEach(function(t){
            var on = t.getAttribute('data-as-tab-index') === idx;
            t.classList.toggle('as-tab--active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function(p){
            var on = p.getAttribute('data-as-panel-index') === idx;
            p.classList.toggle('as-panel--hidden', !on);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-about-cta-strip"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-about-cta-strip"].rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    roots.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-about-impact"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-about-impact"].rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    roots.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-about-mission-vision"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-about-mission-vision"].rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    roots.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-about-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-section-type="cs-about-timeline"]');
    roots.forEach(function (root) {
      var buttons = root.querySelectorAll('.at-year-btn');
      var img = root.querySelector('.at-detail-img');
      var yearEl = root.querySelector('.at-detail-year');
      var titleEl = root.querySelector('.at-detail-title');
      var eventEl = root.querySelector('.at-detail-event');
      var counterEl = root.querySelector('.at-detail-counter');
      var total = buttons.length;
      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (img && btn.dataset.image) {
            img.src = btn.dataset.image;
            img.removeAttribute('srcset');
            img.alt = btn.dataset.title || '';
          }
          if (yearEl) yearEl.textContent = btn.dataset.year || '';
          if (titleEl) titleEl.textContent = btn.dataset.title || '';
          if (eventEl) eventEl.textContent = btn.dataset.event || '';
          if (counterEl) counterEl.textContent = 'Milestone ' + (i + 1) + ' of ' + total;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-about-why-shop"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-about-why-shop"].rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    roots.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-apparel-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('[data-section-type="cs-apparel-cta"].rv');
  if (!('IntersectionObserver' in window)) {
    roots.forEach(function(el){ el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
  roots.forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-article-artisan"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('.ac-wrap .rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      roots.forEach(function(el){ io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-article-sustainable"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('#su-{{ section.id }} .rv');
  if(!els.length) return;
  if(window.matchMedia('(prefers-reduced-motion:reduce)').matches){
    els.forEach(function(el){ el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  },{ threshold: 0.12 });
  els.forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-article-weekend"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-article-weekend"] .rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    roots.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-california89"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('.rv');
  if(!els.length) return;

  if(window.matchMedia('(prefers-reduced-motion:reduce)').matches){
    els.forEach(function(el){ el.classList.add('is-in'); });
    return;
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  },{ threshold:0.12 });

  els.forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scopes = document.querySelectorAll('[data-section-type="cs-header"]');
    scopes.forEach(function (scope) {
      // Drawer is a sibling of the nav (inside the parent <header>), not a child of scope.
      var headerRoot = scope.closest('header') || scope.parentNode || scope;
      var nav = scope; // scope IS the <nav> with [data-hd-nav]
      var burger = scope.querySelector('[data-hd-burger]');
      var drawer = headerRoot.querySelector('[data-hd-drawer]');
      var iconMenu = scope.querySelector('[data-hd-icon-menu]');
      var iconClose = scope.querySelector('[data-hd-icon-close]');

      // Scroll state
      if (nav) {
        var overHero = nav.getAttribute('data-hd-over-hero') === 'true';
        var onScroll = function () {
          if (window.scrollY > 50) {
            nav.classList.add('bg-white/98','backdrop-blur-md','shadow-sm');
            nav.classList.remove('bg-white');
            if (overHero) nav.classList.remove('hd-over-hero');
          } else {
            nav.classList.remove('bg-white/98','backdrop-blur-md','shadow-sm');
            if (overHero) {
              nav.classList.add('hd-over-hero');
              nav.classList.remove('bg-white');
            } else {
              nav.classList.add('bg-white');
            }
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      if (!burger || !drawer) return;

      function open() {
        drawer.classList.remove('opacity-0','pointer-events-none');
        drawer.classList.add('opacity-100','pointer-events-auto');
        burger.setAttribute('aria-expanded', 'true');
        if (iconMenu) iconMenu.classList.add('hidden');
        if (iconClose) iconClose.classList.remove('hidden');
        document.documentElement.style.overflow = 'hidden';
      }
      function close() {
        drawer.classList.add('opacity-0','pointer-events-none');
        drawer.classList.remove('opacity-100','pointer-events-auto');
        burger.setAttribute('aria-expanded', 'false');
        if (iconMenu) iconMenu.classList.remove('hidden');
        if (iconClose) iconClose.classList.add('hidden');
        document.documentElement.style.overflow = '';
      }
      function toggle() {
        if (burger.getAttribute('aria-expanded') === 'true') close(); else open();
      }
      // Dropdown hover with grace delay so cursor can bridge from trigger to panel
      scope.querySelectorAll('[data-hd-dropdown]').forEach(function(dd) {
        var panel = dd.querySelector('.hd-panel');
        var isMega = panel && panel.classList.contains('hd-mega');
        var closeTimer = null;
        function positionMega() {
          if (!panel || !isMega) return;
          var rect = nav ? nav.getBoundingClientRect() : { bottom: 80 };
          panel.style.top = rect.bottom + 'px';
        }
        function open() {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          // Close any other open dropdowns
          scope.querySelectorAll('[data-hd-dropdown].hd-open').forEach(function(o){ if (o !== dd) o.classList.remove('hd-open'); });
          positionMega();
          dd.classList.add('hd-open');
        }
        function close() { dd.classList.remove('hd-open'); }
        function scheduleClose() {
          if (closeTimer) clearTimeout(closeTimer);
          closeTimer = setTimeout(close, 180);
        }
        function cancelClose() {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        }
        dd.addEventListener('mouseenter', open);
        dd.addEventListener('mouseleave', scheduleClose);
        if (panel) {
          panel.addEventListener('mouseenter', cancelClose);
          panel.addEventListener('mouseleave', scheduleClose);
        }
        // Keyboard accessibility
        var trigger = dd.querySelector('a');
        if (trigger) {
          trigger.addEventListener('focus', open);
          dd.addEventListener('focusout', function(e){
            if (!dd.contains(e.relatedTarget)) close();
          });
        }
        if (isMega) {
          window.addEventListener('scroll', function() {
            if (dd.classList.contains('hd-open')) positionMega();
          }, { passive: true });
        }
      });

      burger.addEventListener('click', toggle);
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('a')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-shop-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Scroll reveal with stagger
    var cards = document.querySelectorAll('.pc-card-shop');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            var delay = Array.from(cards).indexOf(entry.target) % 4 * 80;
            setTimeout(function () { entry.target.classList.add('spr-visible'); }, delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      cards.forEach(function (c) { c.classList.add('spr-visible'); });
    }

    // Sort
    var sortEl = document.querySelector('.spr-sort');
    var grid = document.querySelector('.spr-wrap .grid');
    if (sortEl && grid) {
      sortEl.addEventListener('change', function () {
        var allCards = Array.from(grid.querySelectorAll('.pc-card-shop'));
        var visible = allCards.filter(function (c) { return !c.hidden; });
        var hidden = allCards.filter(function (c) { return c.hidden; });
        var val = sortEl.value;
        visible.sort(function (a, b) {
          if (val === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
          if (val === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
          return 0;
        });
        visible.forEach(function (c) { grid.appendChild(c); });
        hidden.forEach(function (c) { grid.appendChild(c); });
      });
    }

    // Listen for filter events from subnav
    document.addEventListener('ssn:filter', function (e) {
      var filter = e.detail.filter;
      var allCards = document.querySelectorAll('.pc-card-shop');
      var count = 0;
      allCards.forEach(function (c) {
        var tags = (c.dataset.tags || '').split(',').map(function (t) { return t.trim(); }).filter(function (t) { return t !== ''; });
        var show = filter === 'all' || tags.some(function (t) {
          return t.indexOf(filter) !== -1 || filter.indexOf(t) !== -1;
        });
        if (show) { c.removeAttribute('hidden'); count++; }
        else { c.setAttribute('hidden', ''); }
      });
      var countEl = document.querySelector('.spr-count');
      if (countEl) countEl.textContent = count;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-shop-subnav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="cs-shop-subnav"]').forEach(function (section) {
      section.querySelectorAll('.ssn-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          // Active state
          section.querySelectorAll('.ssn-pill').forEach(function (p) {
            p.classList.remove('ssn-active');
            p.style.borderColor = '';
            p.style.color = '';
          });
          pill.classList.add('ssn-active');

          // Fire filter event
          var filter = pill.dataset.filter || 'all';
          document.dispatchEvent(new CustomEvent('ssn:filter', { detail: { filter: filter } }));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-stores-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="cs-stores-gallery"]').forEach(function (section) {
      var slides = section.querySelectorAll('[data-gallery-slide]');
      var dots = section.querySelectorAll('[data-gallery-dot]');
      var prevBtn = section.querySelector('[data-gallery-prev]');
      var nextBtn = section.querySelector('[data-gallery-next]');
      var count = slides.length;
      if (count === 0) return;
      var currentIndex = 0;

      function render() {
        slides.forEach(function (s) {
          var idx = parseInt(s.getAttribute('data-index'), 10);
          s.classList.toggle('hidden', idx !== currentIndex);
        });
        dots.forEach(function (d) {
          var idx = parseInt(d.getAttribute('data-index'), 10);
          var active = idx === currentIndex;
          d.classList.toggle('is-active', active);
          if (active) {
            d.classList.add('bg-[var(--c-accent-3)]', 'w-6');
            d.classList.remove('bg-[var(--c-border-2)]', 'w-2');
          } else {
            d.classList.remove('bg-[var(--c-accent-3)]', 'w-6');
            d.classList.add('bg-[var(--c-border-2)]', 'w-2');
          }
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () {
        currentIndex = (currentIndex - 1 + count) % count;
        render();
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        currentIndex = (currentIndex + 1) % count;
        render();
      });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          currentIndex = parseInt(d.getAttribute('data-index'), 10);
          render();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-stores-selector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript && document.currentScript.parentElement;
    // Scope handlers per section instance
    document.querySelectorAll('[data-section-type="cs-stores-selector"]').forEach(function (section) {
      var tabs = section.querySelectorAll('[data-store-target]');
      var panels = section.querySelectorAll('[data-store-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-store-target');
          tabs.forEach(function (t) {
            var isActive = t.getAttribute('data-store-target') === target;
            t.classList.toggle('is-active', isActive);
            if (isActive) {
              t.classList.add('border-[var(--c-accent-3)]', 'bg-[var(--c-accent-3)]', 'text-white');
              t.classList.remove('border-[var(--c-border-2)]', 'bg-white', 'text-[var(--c-text)]');
            } else {
              t.classList.remove('border-[var(--c-accent-3)]', 'bg-[var(--c-accent-3)]', 'text-white');
              t.classList.add('border-[var(--c-border-2)]', 'bg-white', 'text-[var(--c-text)]');
            }
          });
          panels.forEach(function (p) {
            var match = p.getAttribute('data-store-panel') === target;
            p.classList.toggle('hidden', !match);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-stores-services"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="cs-stores-services"]').forEach(function (section) {
      var openers = section.querySelectorAll('[data-modal-target]');
      var panels = section.querySelectorAll('[data-modal-panel]');

      function closeAll() {
        panels.forEach(function (p) { p.classList.add('hidden'); });
        document.body.classList.remove('overflow-hidden');
      }

      openers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-modal-target');
          panels.forEach(function (p) {
            var match = p.getAttribute('data-modal-panel') === id;
            p.classList.toggle('hidden', !match);
          });
          document.body.classList.add('overflow-hidden');
        });
      });

      panels.forEach(function (panel) {
        panel.addEventListener('click', function (e) {
          // Backdrop click closes
          if (e.target === panel) {
            closeAll();
          }
        });
        var closeBtn = panel.querySelector('[data-modal-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            closeAll();
          });
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAll();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
